<template>
	<el-card>
		<div style="width: 50%;">
			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="APPID">
					<el-input v-model="form.appid"></el-input>
				</el-form-item>
				<el-form-item label="SECRET">
					<el-input v-model="form.secret"></el-input>
				</el-form-item>
				<el-form-item label="分享封面">
					<el-upload class="avatar-uploader" name="Image" :headers="headers" :action="action" :show-file-list="false"
					 :on-success="handleUploadSuccess">
						<img v-if="form.intro" :src="form.intro" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
			</el-form>
			<el-button type="primary" @click="onSubmit">提交</el-button>
		</div>
	</el-card>
</template>

<script>
	export default {
		data() {
			return {
				action: this.$c.domain + "common/upload",
				form: {
					appid: '',
					secret: '',
					intro: ""
				},
				headers: {
					token: this.$store.state.userInfo.token
				}
			}
		},
		created() {
			this.getSysInfo()
		},
		methods: {
			onSubmit() {
				this.$H.post("system/baseSet", this.form).then(res => {
					if (res.code == 200) {
						this.$message.success("保存成功")
					}
				})
			},
			handleUploadSuccess(e) {
				if (e.code == 200) {
					this.form.intro = e.result.url;
				}
			},
			getSysInfo() {
				this.$H.get("system/miniConfig").then(res => {
					let data = res.result;
					this.form = {
						appid: data.value,
						secret: data.extend,
						intro: data.intro
					}
				})
			}
		}
	}
</script>

<style>
	/* 上传 */
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 150px;
		height: 150px;
		line-height: 150px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
